import { useState } from 'react';

export default function Services() {
  const [selectedService, setSelectedService] = useState<number | null>(null);

  const services = [
    {
      icon: 'ri-flashlight-fill',
      title: 'Emergencias 24/7',
      description: 'Servicio de urgencias disponible las 24 horas del día, los 7 días de la semana. Respuesta rápida ante cualquier emergencia de fontanería.',
      features: [
        'Respuesta inmediata en menos de 30 minutos',
        'Equipo disponible todos los días del año',
        'Solución de fugas y averías urgentes',
        'Sin recargo por servicio nocturno o festivo'
      ],
      color: 'from-[#3B82F6] to-[#2563EB]',
      image: 'https://readdy.ai/api/search-image?query=Professional%20emergency%20plumber%20working%20urgently%20on%20a%20pipe%20repair%20in%20a%20modern%20home%20with%20tools%20and%20equipment%2C%20dramatic%20lighting%20showing%20quick%20response%20service%20with%20clean%20simple%20background&width=600&height=400&seq=emergency24service&orientation=landscape'
    },
    {
      icon: 'ri-tools-fill',
      title: 'Instalación',
      description: 'Instalación profesional de sistemas de fontanería completos para hogares y negocios con garantía de calidad.',
      features: [
        'Instalación de tuberías y sistemas completos',
        'Montaje de sanitarios y grifería premium',
        'Conexión de electrodomésticos',
        'Garantía de 2 años en todas las instalaciones'
      ],
      color: 'from-[#2563EB] to-[#1D4ED8]',
      image: 'https://readdy.ai/api/search-image?query=Professional%20plumber%20installing%20new%20modern%20bathroom%20fixtures%20and%20pipes%20in%20a%20contemporary%20home%20showing%20quality%20installation%20work%20with%20clean%20simple%20background&width=600&height=400&seq=installationservice&orientation=landscape'
    },
    {
      icon: 'ri-settings-3-fill',
      title: 'Mantenimiento',
      description: 'Mantenimiento preventivo y correctivo para asegurar el óptimo funcionamiento de tus instalaciones.',
      features: [
        'Revisión completa de instalaciones',
        'Detección temprana de problemas',
        'Limpieza de tuberías y desagües',
        'Planes de mantenimiento personalizados'
      ],
      color: 'from-[#1D4ED8] to-[#1E40AF]',
      image: 'https://readdy.ai/api/search-image?query=Professional%20plumber%20performing%20maintenance%20inspection%20on%20plumbing%20system%20checking%20pipes%20and%20fixtures%20with%20diagnostic%20tools%20in%20modern%20setting%20with%20clean%20simple%20background&width=600&height=400&seq=maintenanceservice&orientation=landscape'
    },
    {
      icon: 'ri-water-flash-fill',
      title: 'Sistemas de Drenaje',
      description: 'Soluciones completas para sistemas de drenaje, desatascos y limpieza de tuberías.',
      features: [
        'Desatasco de tuberías y desagües',
        'Limpieza con equipos de alta presión',
        'Reparación de sistemas de alcantarillado',
        'Inspección con cámara especializada'
      ],
      color: 'from-[#1E40AF] to-[#1E3A8A]',
      image: 'https://readdy.ai/api/search-image?query=Professional%20plumber%20working%20on%20drainage%20system%20and%20pipe%20cleaning%20with%20high%20pressure%20equipment%20showing%20expertise%20in%20modern%20plumbing%20with%20clean%20simple%20background&width=600&height=400&seq=drainageservice&orientation=landscape'
    },
    {
      icon: 'ri-fire-fill',
      title: 'Calentadores',
      description: 'Instalación, reparación y mantenimiento de calentadores de agua y sistemas de calefacción.',
      features: [
        'Instalación de calentadores eléctricos y gas',
        'Reparación de averías y fugas',
        'Mantenimiento preventivo anual',
        'Asesoramiento en eficiencia energética'
      ],
      color: 'from-[#1E3A8A] to-[#3B82F6]',
      image: 'https://readdy.ai/api/search-image?query=Professional%20plumber%20installing%20and%20repairing%20modern%20water%20heater%20system%20showing%20technical%20expertise%20with%20tools%20and%20equipment%20in%20clean%20simple%20background&width=600&height=400&seq=heaterservice&orientation=landscape'
    },
    {
      icon: 'ri-search-eye-line',
      title: 'Detección de Fugas',
      description: 'Localización precisa de fugas de agua con tecnología avanzada sin necesidad de obras destructivas.',
      features: [
        'Detección con equipos de última generación',
        'Localización exacta sin romper paredes',
        'Inspección termográfica y acústica',
        'Informe detallado con soluciones'
      ],
      color: 'from-[#3B82F6] to-[#2563EB]',
      image: 'https://readdy.ai/api/search-image?query=Professional%20plumber%20using%20advanced%20leak%20detection%20equipment%20and%20thermal%20imaging%20technology%20to%20locate%20water%20leaks%20in%20pipes%20without%20breaking%20walls%20showing%20modern%20diagnostic%20tools%20with%20clean%20simple%20background&width=600&height=400&seq=leakdetectionservice&orientation=landscape'
    }
  ];

  return (
    <>
      <section id="servicios" className="py-16 sm:py-20 lg:py-24 bg-gradient-to-br from-[#EFF6FF] to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          {/* Header */}
          <div className="text-center mb-12 sm:mb-16">
            <div className="inline-block px-4 sm:px-6 py-2 border-2 border-[#3B82F6] rounded-full mb-4 sm:mb-6">
              <span className="text-[#3B82F6] text-xs sm:text-sm font-semibold">Nuestros Servicios</span>
            </div>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold text-[#1e3a8a] mb-4 sm:mb-6 px-4">
              Soluciones Completas
              <span className="block text-[#3B82F6] mt-2">de Fontanería</span>
            </h2>
            <p className="text-base sm:text-lg text-gray-600 max-w-2xl mx-auto px-4">
              Ofrecemos servicios profesionales de fontanería con la más alta calidad y garantía. Tu satisfacción es nuestra prioridad.
            </p>
          </div>

          {/* Services Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
            {services.map((service, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl p-6 sm:p-8 border border-gray-200 hover:border-[#3B82F6]/30 hover:shadow-2xl transition-all group"
              >
                {/* Icon */}
                <div className={`w-14 h-14 sm:w-16 sm:h-16 rounded-xl bg-gradient-to-br ${service.color} flex items-center justify-center mb-4 sm:mb-6 group-hover:scale-110 transition-transform`}>
                  <div className="w-7 h-7 sm:w-8 sm:h-8 flex items-center justify-center">
                    <i className={`${service.icon} text-white text-xl sm:text-2xl`}></i>
                  </div>
                </div>

                {/* Content */}
                <h3 className="text-xl sm:text-2xl font-bold text-[#1e3a8a] mb-3 sm:mb-4">{service.title}</h3>
                <p className="text-sm sm:text-base text-gray-600 mb-4 sm:mb-6 leading-relaxed">{service.description}</p>

                {/* Button */}
                <button
                  onClick={() => setSelectedService(index)}
                  className="w-full bg-gradient-to-r from-[#3B82F6] to-[#2563EB] text-white py-3 sm:py-4 rounded-xl text-sm sm:text-base font-bold hover:shadow-xl hover:shadow-[#3B82F6]/30 transition-all flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer"
                >
                  <span>Más detalles</span>
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-arrow-right-line"></i>
                  </div>
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Service Detail Modal */}
      {selectedService !== null && (
        <div
          className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50 flex items-center justify-center p-4 sm:p-6"
          onClick={() => setSelectedService(null)}
        >
          <div
            className="bg-white rounded-2xl sm:rounded-3xl max-w-4xl w-full max-h-[90vh] overflow-y-auto"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Header Image */}
            <div className="relative h-48 sm:h-64 w-full rounded-t-2xl sm:rounded-t-3xl overflow-hidden">
              <img
                src={services[selectedService].image}
                alt={services[selectedService].title}
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
              <button
                onClick={() => setSelectedService(null)}
                className="absolute top-4 right-4 sm:top-6 sm:right-6 w-10 h-10 sm:w-12 sm:h-12 bg-white/90 backdrop-blur-sm rounded-full flex items-center justify-center hover:bg-white transition-all cursor-pointer"
              >
                <div className="w-5 h-5 sm:w-6 sm:h-6 flex items-center justify-center">
                  <i className="ri-close-line text-xl sm:text-2xl text-gray-900"></i>
                </div>
              </button>
            </div>

            {/* Content */}
            <div className="p-6 sm:p-8 lg:p-10">
              {/* Icon & Title */}
              <div className="flex items-center gap-4 sm:gap-6 mb-4 sm:mb-6">
                <div className={`w-16 h-16 sm:w-20 sm:h-20 rounded-xl sm:rounded-2xl bg-gradient-to-br ${services[selectedService].color} flex items-center justify-center flex-shrink-0`}>
                  <div className="w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center">
                    <i className={`${services[selectedService].icon} text-white text-2xl sm:text-3xl`}></i>
                  </div>
                </div>
                <div>
                  <h3 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-[#1e3a8a]">{services[selectedService].title}</h3>
                  <p className="text-sm sm:text-base text-gray-600 mt-1 sm:mt-2">{services[selectedService].description}</p>
                </div>
              </div>

              {/* Features */}
              <div className="mb-6 sm:mb-8">
                <h4 className="text-lg sm:text-xl font-bold text-[#1e3a8a] mb-4 sm:mb-6">¿Qué incluye este servicio?</h4>
                <div className="space-y-3 sm:space-y-4">
                  {services[selectedService].features.map((feature, idx) => (
                    <div key={idx} className="flex items-start gap-3 sm:gap-4">
                      <div className="w-7 h-7 sm:w-8 sm:h-8 rounded-lg bg-gradient-to-br from-[#3B82F6]/10 to-[#2563EB]/10 flex items-center justify-center flex-shrink-0 mt-0.5 sm:mt-1">
                        <div className="w-4 h-4 sm:w-5 sm:h-5 flex items-center justify-center">
                          <i className="ri-checkbox-circle-fill text-[#3B82F6] text-base sm:text-lg"></i>
                        </div>
                      </div>
                      <p className="text-sm sm:text-base lg:text-lg text-gray-700 leading-relaxed">{feature}</p>
                    </div>
                  ))}
                </div>
              </div>

              {/* CTA Buttons */}
              <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 pt-4 sm:pt-6 border-t border-gray-200">
                <a
                  href="tel:+34643707657"
                  className="flex-1 bg-gradient-to-r from-[#3B82F6] to-[#2563EB] text-white py-4 sm:py-5 rounded-full text-sm sm:text-base font-bold hover:shadow-2xl hover:shadow-[#3B82F6]/30 transition-all flex items-center justify-center gap-3 whitespace-nowrap cursor-pointer"
                >
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-phone-fill"></i>
                  </div>
                  <span>Llamar Ahora</span>
                </a>
                <button
                  onClick={() => {
                    setSelectedService(null);
                    setTimeout(() => {
                      document.getElementById('contacto')?.scrollIntoView({ behavior: 'smooth' });
                    }, 100);
                  }}
                  className="flex-1 bg-white border-2 border-[#3B82F6] text-[#3B82F6] py-4 sm:py-5 rounded-full text-sm sm:text-base font-bold hover:bg-[#3B82F6] hover:text-white transition-all flex items-center justify-center gap-3 whitespace-nowrap cursor-pointer"
                >
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-mail-fill"></i>
                  </div>
                  <span>Solicitar Presupuesto</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
